var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewLogoV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 416.77 225.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#0379a1;}.cls-3{fill:#f7901e;}.cls-4{fill:#f04c23;}.cls-5{fill:#29296f;}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 198.31,
    y1: 5.18,
    x2: 137.57,
    y2: 91.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#fbaa19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fbab18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fcbf0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fdcb08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fecf07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 231.62,
    y1: 9.59,
    x2: 231.62,
    y2: 138.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#e31e26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#d71d24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#bc1c21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#a81b1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9c1b1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#991b1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 179.46,
    y1: 13.64,
    x2: 244.08,
    y2: 56.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#29296f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#243275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#12588c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#07709b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#0379a1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m20.76,203.87v-45.4h8.89l16.54,26.92-5.84-.07,16.73-26.85h8.5v45.4h-9.53v-15.57c0-3.89.1-7.39.29-10.51.19-3.11.53-6.2,1.01-9.27l1.17,3.05-13.3,20.62h-4.28l-13.04-20.49,1.1-3.18c.47,2.9.81,5.87,1.01,8.92.19,3.05.29,6.67.29,10.86v15.57h-9.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m78.28,218.79l7.52-17.64.13,5.32-16.73-36.9h10.44l8.37,19.78c.35.74.68,1.59,1.01,2.56.32.97.59,1.89.81,2.76l-1.56.71c.3-.73.62-1.58.94-2.53.32-.95.66-1.97,1.01-3.05l7.2-20.24h10.51l-14.4,34.31-5.9,14.92h-9.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m117.33,204.52c-1.64,0-3.18-.19-4.61-.58-1.43-.39-2.72-.93-3.89-1.62-1.17-.69-2.23-1.55-3.18-2.56-.95-1.02-1.75-2.15-2.4-3.41l5.64-5.9c.74.99,1.42,1.82,2.04,2.46.63.65,1.23,1.18,1.82,1.59.58.41,1.18.69,1.78.84.61.15,1.25.23,1.95.23,1.21,0,2.28-.28,3.21-.84.93-.56,1.64-1.34,2.14-2.34.5-.99.75-2.14.75-3.44v-21.86h-8.3v-8.63h24.84v8.63h-7.01v22.96c0,2.16-.37,4.13-1.1,5.9-.74,1.77-1.77,3.3-3.11,4.57-1.34,1.28-2.91,2.26-4.7,2.95-1.79.69-3.75,1.04-5.87,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m154.94,204.52c-3.5,0-6.63-.77-9.37-2.3-2.75-1.53-4.91-3.64-6.49-6.32-1.58-2.68-2.37-5.75-2.37-9.21s.79-6.53,2.37-9.21c1.58-2.68,3.74-4.79,6.49-6.32,2.75-1.53,5.87-2.3,9.37-2.3s6.56.77,9.31,2.3c2.75,1.54,4.9,3.64,6.45,6.32,1.56,2.68,2.34,5.75,2.34,9.21s-.78,6.53-2.34,9.21c-1.56,2.68-3.71,4.79-6.45,6.32-2.75,1.54-5.85,2.3-9.31,2.3Zm0-8.04c1.69,0,3.2-.42,4.54-1.26,1.34-.84,2.39-2.01,3.15-3.5.76-1.49,1.11-3.17,1.07-5.03.04-1.9-.31-3.6-1.07-5.09-.76-1.49-1.81-2.66-3.15-3.5-1.34-.84-2.85-1.26-4.54-1.26s-3.27.43-4.6,1.3c-1.34.87-2.4,2.03-3.18,3.5-.78,1.47-1.15,3.16-1.1,5.06-.04,1.86.32,3.54,1.1,5.03.78,1.49,1.84,2.66,3.18,3.5,1.34.84,2.88,1.26,4.6,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m197.23,204.52c-1.51,0-2.98-.22-4.41-.65s-2.72-1.03-3.89-1.78c-1.17-.76-2.14-1.62-2.92-2.59-.78-.97-1.28-1.98-1.49-3.02l2.08-.78-.45,8.04h-8.69v-47.86h9.27v21.73l-1.82-.71c.26-1.04.76-2.04,1.49-3.02.73-.97,1.66-1.84,2.79-2.59,1.12-.76,2.36-1.35,3.7-1.78,1.34-.43,2.72-.65,4.15-.65,2.98,0,5.65.77,8.01,2.3,2.36,1.54,4.2,3.64,5.55,6.32,1.34,2.68,2.01,5.75,2.01,9.21s-.66,6.53-1.98,9.21c-1.32,2.68-3.15,4.79-5.48,6.32-2.33,1.54-4.97,2.3-7.91,2.3Zm-2.2-7.85c1.73,0,3.23-.42,4.51-1.26,1.27-.84,2.28-2.01,3.02-3.5.73-1.49,1.1-3.23,1.1-5.22s-.36-3.67-1.07-5.19c-.71-1.51-1.72-2.68-3.02-3.5-1.3-.82-2.81-1.23-4.54-1.23s-3.24.41-4.54,1.23c-1.3.82-2.3,1.99-3.02,3.5-.71,1.51-1.07,3.24-1.07,5.19s.36,3.73,1.07,5.22c.71,1.49,1.72,2.66,3.02,3.5,1.3.84,2.81,1.26,4.54,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m218.24,203.87v-45.4h8.89l16.54,26.92-5.84-.07,16.73-26.85h8.5v45.4h-9.53v-15.57c0-3.89.1-7.39.29-10.51.19-3.11.53-6.2,1.01-9.27l1.17,3.05-13.3,20.62h-4.28l-13.04-20.49,1.1-3.18c.47,2.9.81,5.87,1.01,8.92.19,3.05.29,6.67.29,10.86v15.57h-9.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m282.52,204.52c-2.85,0-5.43-.78-7.72-2.34-2.29-1.56-4.11-3.67-5.45-6.36-1.34-2.68-2.01-5.75-2.01-9.21s.68-6.53,2.04-9.21c1.36-2.68,3.21-4.78,5.55-6.29,2.34-1.51,4.99-2.27,7.98-2.27,1.69,0,3.23.25,4.64.75,1.4.5,2.64,1.18,3.7,2.04,1.06.87,1.96,1.86,2.69,2.98.74,1.12,1.25,2.34,1.56,3.63l-1.95-.32v-8.37h9.15v34.31h-9.27v-8.24l2.08-.19c-.35,1.21-.91,2.36-1.69,3.44-.78,1.08-1.74,2.04-2.89,2.89-1.15.84-2.43,1.51-3.86,2.01-1.43.5-2.94.75-4.54.75Zm2.53-7.98c1.73,0,3.24-.41,4.54-1.23,1.3-.82,2.3-1.98,3.02-3.47.71-1.49,1.07-3.23,1.07-5.22s-.36-3.65-1.07-5.12c-.71-1.47-1.72-2.63-3.02-3.47-1.3-.84-2.81-1.26-4.54-1.26s-3.17.42-4.44,1.26c-1.28.84-2.28,2-3.02,3.47-.74,1.47-1.1,3.18-1.1,5.12s.37,3.73,1.1,5.22c.73,1.49,1.74,2.65,3.02,3.47,1.27.82,2.76,1.23,4.44,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m306.19,177.8v-8.24h22.7v8.24h-22.7Zm6.42,26.07v-43h9.21v43h-9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m346.86,204.52c-3.29,0-6.23-.78-8.82-2.34-2.59-1.56-4.64-3.67-6.13-6.36-1.49-2.68-2.24-5.73-2.24-9.14s.75-6.46,2.24-9.14c1.49-2.68,3.53-4.8,6.13-6.36,2.59-1.56,5.53-2.34,8.82-2.34,3.07,0,5.88.56,8.43,1.69,2.55,1.12,4.54,2.68,5.97,4.67l-5.06,6.1c-.61-.82-1.36-1.57-2.27-2.24-.91-.67-1.89-1.2-2.95-1.59-1.06-.39-2.15-.58-3.28-.58-1.77,0-3.34.42-4.7,1.26-1.36.84-2.43,2-3.21,3.47-.78,1.47-1.17,3.16-1.17,5.06s.4,3.46,1.2,4.93c.8,1.47,1.89,2.64,3.28,3.5,1.38.87,2.94,1.3,4.67,1.3,1.12,0,2.18-.15,3.18-.45.99-.3,1.93-.78,2.82-1.43.89-.65,1.7-1.43,2.43-2.34l4.99,6.1c-1.43,1.86-3.45,3.36-6.06,4.51-2.62,1.14-5.37,1.72-8.27,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m364.5,203.87v-47.99h9.08v20.69l-1.82.78c.48-1.56,1.33-2.97,2.56-4.25,1.23-1.27,2.71-2.3,4.44-3.08,1.73-.78,3.54-1.17,5.45-1.17,2.59,0,4.77.52,6.52,1.56s3.07,2.61,3.96,4.7c.89,2.1,1.33,4.68,1.33,7.75v21.01h-9.21v-20.3c0-1.56-.22-2.85-.65-3.89-.43-1.04-1.09-1.79-1.98-2.27-.89-.48-1.98-.69-3.28-.65-1.04,0-2,.16-2.89.49-.89.32-1.64.79-2.27,1.39-.63.61-1.12,1.3-1.49,2.08-.37.78-.55,1.62-.55,2.53v20.62h-9.21Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m144.19,94.86c-1.86-5.48,1.07-11.43,6.55-13.29,5.31-1.8,11.07.91,13.1,6.08-1.39-4.31-2.15-8.94-2.15-13.78,0-24.3,18.84-43.33,42.89-43.33-5.79,0-10.48-4.69-10.48-10.48s4.69-10.48,10.48-10.48c-35.8,0-63.85,28.24-63.85,64.29,0,8.1,1.48,15.96,4.27,23.27-.29-.75-.57-1.52-.83-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m178.5,108.34c-6.56-5.04-11.67-11.99-14.46-20.22-1.86-5.48-7.82-8.41-13.29-6.55-5.48,1.86-8.41,7.81-6.55,13.29,4.1,12.08,11.57,22.31,21.15,29.79-4.01-3.61-4.65-9.75-1.32-14.12,3.5-4.61,10.08-5.5,14.68-1.99l-.21-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m204.6,138.17c-5.79,0-10.48-4.69-10.48-10.48s4.69-10.48,10.48-10.48c24.02,0,43.55-19.44,43.55-43.34s-19.13-43.33-43.55-43.33c-5.79,0-10.48-4.69-10.48-10.48s4.69-10.48,10.48-10.48c17.26,0,33.43,6.57,45.54,18.51,12.23,12.06,18.97,28.32,18.97,45.78,0,35.45-28.94,64.29-64.51,64.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m194.12,127.69c0-5.79,4.69-10.48,10.48-10.48-9.49,0-18.44-3-25.9-8.67-4.61-3.51-11.18-2.62-14.68,1.99-3.51,4.6-2.61,11.18,1.99,14.68,11.13,8.47,24.47,12.95,38.59,12.95-5.79,0-10.48-4.69-10.48-10.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m280.82,8.84c-4.21-3.97-10.84-3.79-14.81.42l-62.2,65.86-30.82-30.82c-4.91,5.37-8.45,12.03-10.15,19.49l33.77,33.77s.08.07.12.11c.03.03.06.06.09.1.09.08.18.16.28.24.14.12.28.25.42.36.13.1.27.2.4.29.14.1.29.21.43.3.15.09.29.18.44.26.14.08.29.17.43.25.16.08.33.15.49.23.14.06.28.13.42.19.18.07.36.13.54.19.14.05.27.1.41.14.19.06.39.1.59.14.13.03.25.06.38.09.22.04.44.07.66.09.11.01.21.03.32.04.31.03.62.04.93.04.02,0,.04,0,.05,0,.34,0,.69-.02,1.03-.05.08,0,.16-.03.25-.04.26-.03.51-.06.77-.12.11-.02.22-.06.34-.08.22-.05.44-.1.66-.17.13-.04.25-.09.38-.13.2-.07.4-.13.59-.22.14-.06.27-.12.4-.19.18-.08.36-.17.54-.26.14-.07.27-.16.4-.24.17-.1.34-.2.5-.31.13-.09.26-.19.38-.28.16-.12.32-.24.47-.37.12-.1.23-.21.35-.31.11-.1.23-.2.35-.31.04-.04.07-.09.11-.13.03-.03.06-.06.09-.09l69.61-73.7c3.97-4.21,3.78-10.84-.42-14.81Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogoV);
export default __webpack_public_path__ + "static/media/new-logo-v.a38b8b054cf2ae0acdeba938fb774bb3.svg";
export { ForwardRef as ReactComponent };